<template>
    <!-- <CommonButton translationKey="store_with_us" /> -->
    <section>
        <div v-for="(item, index) in contentArray" :key="index" class="content-section" ref="contentRefs">
            <div class="img-div">
                <img style="width: 100%; height: 100%; object-position: center;"
                    :src="require(`@/assets/images/${item.img}.png`)" alt="img" />
            </div>
            <div class="content">
                <h2 class="font-48 fw-500 text-start">{{ $t(item.title) }}</h2>
                <p style="margin-bottom: 32px;" class="font-18 text-start">{{ $t(item.description) }}</p>
                <!-- if id 4 show else dont -->
                <template v-if="item.id === 4">
                    <a class="btn btn-primary text-small askQoutation fw-600"
                        :href="`${BASE_FRONT_URL}` + `/${$i18n.locale}` + '/dashboard/rfq' + `${refId ? '?ref=' + refId : ''}`">
                        {{ $t('common.store_with_us') }}
                    </a>
                    <!-- <router-link to="/dashboard/rfq">
                        <CommonButton translationKey="store_with_us" />
                    </router-link> -->
                </template>
            </div>
        </div>
    </section>
</template>
  
<script >
 
//import CommonButton from "@/components/global/CommonButton.vue";
import { env } from "@/static/env";
export default {
    components: {
  //      CommonButton,
    },
    computed: {
        refId() {
            return this.$route.query.ref;
        }
    },
    data() {
        return {
            BASE_FRONT_URL: env.BASE_FRONT_URL,
            contentArray: [
                {
                    id: 1,
                    title: "serviesInner.transportation.title1",
                    description: "serviesInner.transportation.desc1",
                    img: "costEffective"
                },
                {
                    id: 2,
                    title: "serviesInner.transportation.title2",
                    description: "serviesInner.transportation.desc2",
                    img: "timeSaving"
                },
                {
                    id: 3,
                    title: "serviesInner.transportation.title3",
                    description: "serviesInner.transportation.desc3",
                    img: "scalability"
                },
                {
                    id: 4,
                    title: "serviesInner.transportation.title4",
                    description: "serviesInner.transportation.desc4",
                    img: "improvedCustomerCare"
                }

            ],
            currentIndex: 0
        };
    },

} 
</script>
  
<style lang="scss" scoped>
section {
    background-color: #f8f9fb;
    margin: 0;
    padding: 120px 0px 120px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 1024px) {
        padding: 120px 24px 120px 24px;
    }
}

.content-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1464px;
    height: 100vh;

    @media screen and (max-width: 1500px) {
        padding: 0px 80px;
        width: 100%;
    }

    @media screen and (max-width: 1200px) {
        padding: 0px 24px;
        width: 100%;
        height: auto;
        margin-bottom: 80px;
    }

    @media screen and (max-width: 1024px) {
        height: auto;
        width: 100%;
        flex-direction: column-reverse;
        margin-top: 24px;
        padding: 0px 0px;
    }
}

.img-div {
    width: 697px;

    height: 598px;
    background: transparent !important;

    @media screen and (max-width: 1500px) {
        height: auto;
        width: 40%;
        object-position: center;
    }

    @media screen and (max-width: 1024px) {
        width: 100%;
        margin-top: 24px;
        height: auto;
    }
}

.content {
    width: 623px;

    @media screen and (max-width: 1500px) {

        width: 50%;
        object-position: center;
    }

    @media screen and (max-width: 1024px) {
        width: 100%;
    }

    h2 {
        margin: 0;
        padding: 0;
    }

    p {
        margin: 0;
        padding: 32px 0px 0px 0px;
    }
}
</style>
  